import React from 'react';
import { connect } from 'react-redux';
import {
  columnCode,
  columnDescription,
  columnName,
  columnMultiSelect,
  columnVisibility,
  columnTools,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import { toggleSearchesSelected } from '../actions';

const SearchesTableColumns = ({
  category,
  items,
  onCheckBoxClick,
  columns = [columnMultiSelect, columnName, columnCode, columnDescription, columnVisibility, columnTools],
}) => (
  <NameDescriptionColumns
    entity="search"
    onCheckBoxClick={({ selected }) => onCheckBoxClick(category, selected)}
    items={items}
    columns={columns}
  >
    {hasColumn(columns, columnVisibility) && (<UnsortedColumn columnId={columnVisibility} />)}
  </NameDescriptionColumns>
);

const mapDispatchToProps = {
  onCheckBoxClick: toggleSearchesSelected,
};

export default connect(null, mapDispatchToProps)(SearchesTableColumns);
